export const getVersionPath = (version) => ("calcs/" + version + "/")